import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { discountPoliciesMessages } from 'src/features/discountPolicies/utils/messages';
import DiscountsTable from 'src/features/discounts/components/tables/DiscountsTable';

const DiscountLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(discountPoliciesMessages.discounts));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <DiscountsTable />;
};

export default DiscountLayout;
